import { format, parseISO, startOfMonth } from 'date-fns'
import isNil from 'lodash-es/isNil'

import { DATE_API_DATA_FORMAT_SHORT } from '../../../../../constants/date'
import { transposeToUkTimezoneDate } from '../../../../../utils/date'
import {
  TASK_FORM_DEADLINE_FIELD_NAME,
  TASK_FORM_INITIAL_VALUES,
} from '../../../../Task'

// The day in focus (CAL-01 §7.1a): today while it is shown, else the first day of the week, the month or the day
export function getCalendarViewFocusDay({
  anchor,
  days,
  isMonthMode,
  isTodayVisible,
  today,
}) {
  if (isTodayVisible) {
    return today
  }

  return isMonthMode
    ? format(startOfMonth(anchor), DATE_API_DATA_FORMAT_SHORT)
    : days[0].date
}

export function getCalendarViewTaskInitialValues({ calendar, timezone }) {
  return {
    ...TASK_FORM_INITIAL_VALUES,
    [TASK_FORM_DEADLINE_FIELD_NAME]: transposeToUkTimezoneDate(
      parseISO(getCalendarViewFocusDay(calendar)),
      timezone
    ),
  }
}

export function getCalendarViewPeriodKey({ anchor, mode }) {
  return `${mode}:${format(anchor, DATE_API_DATA_FORMAT_SHORT)}`
}

// TODO: the saved task's type carries calendar_relevant once the create response returns it (TM-01-50)
export function getIsCalendarViewTaskOutOfCalendar(task) {
  return task?.type?.calendar_relevant === false
}

export function getIsCalendarViewTaskNoteShown({ calendar, notePeriodKey }) {
  return notePeriodKey === getCalendarViewPeriodKey(calendar)
}

export function getIsCalendarViewTaskNoteStale({ calendar, notePeriodKey }) {
  return (
    !isNil(notePeriodKey) &&
    !getIsCalendarViewTaskNoteShown({ calendar, notePeriodKey })
  )
}
